/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import Axios, { AxiosRequestConfig } from "axios";

const axios = Axios.create();

axios.interceptors.request.use((req) => {
  req.baseURL = process.env.VUE_APP_SALUTARIA_API_URL + "/api";
  req.headers!.authorization = `Bearer ${localStorage.authToken}`;
  return req;
});
export default {
  getCategories() {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/options/categories",
    };
    return axios(options);
  },
  getCategories2() {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/options/activity-category",
    };
    return axios(options);
  },
  getUrgencyLevel() {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/options/urgency",
    };
    return axios(options);
  },
  getMachine(keyword: string | null) {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/machine/search",
      params: {
        q: keyword,
      },
    };
    return axios(options);
  },
  getRegions() {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/options/regions",
    };
    return axios(options);
  },
  getLocations() {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/options/locations",
    };
    return axios(options);
  },
  getMaterials(id: string | null = null) {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/options/materials?woid="+id,
    };
    return axios(options);
  },
  getAreas(region_code: string | null = null) {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/v3/ticket/options/fl/area/"+region_code,
    };
    return axios(options);
  },

  getSections(parentId: string | null = null){
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/v3/ticket/options/fl/section/"+parentId,
    };
    return axios(options);
  },
  getLines(parentId: string | null = null){
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/v3/ticket/options/fl/line/"+parentId,
    };
    return axios(options);
  },
  getSublines(parentId: string | null = null){
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/v3/ticket/options/fl/subline/"+parentId,
    };
    return axios(options);
  },
  getMachines(parentId: string | null = null){
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/v3/ticket/options/fl/equipment/"+parentId,
    };
    return axios(options);
  },
  getTechnicians(workorder_id: string | null = null) {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/v2/activities/options/technician",
      params: {
        workorder_id: workorder_id,
      },
    };
    return axios(options);
  },
  getQcUsers() {
    const options: AxiosRequestConfig = {
      method: "get",
      url: "/options/qc-user",
    };
    return axios(options);
  },
  // getSubMachines(parentId: string | null = null){
  //   const options: AxiosRequestConfig = {
  //     method: "get",
  //     url: "/v3/ticket/options/fl/subequipment/"+parentId,
  //   };
  //   return axios(options);
  // },
};
